<div class="brn-form__checkbox" (click)="onClick()">
  <span class="checkbox" [ngClass]="{ active: value }">
    <i class="material-icons"> check </i>
  </span>
  <p class="label">
    <ng-content></ng-content>
  </p>
</div>
